import userService from '../../services/user-service';

const state = () => ({

    loading: false,
    users: [],
    error: null
})

const actions = {
    getAll({ commit }) {
        commit('Loading');

        userService.getAll()
            .then(
                users => commit('Success', users.data),
                error => commit('Failure', error)
            );
    },
    add({ commit, state }, data) {
        userService.create(data)
            .then(
                response => {
                    if (response.status == 201) {
                        data.id = response.data.id;
                        state.users.unshift(data);
                        commit('Failure', null)
                    }
                },
                error => commit('Failure', error)
            )

    },
    delete({ commit, state }, data) {
        userService.delete(data.user.id)
            .then(
                response => {
                    state.users.splice(data.index, 1)
                    commit('Failure', null)
                },
                error => commit('Failure', error)
            )
    },
    update({ commit, state }, data) {
        userService.update(data.user.id, data.user)
            .then(
                success => {
                    Object.assign(state.users[data.index], data.user);
                    commit('Failure', null)
                },
                error => commit('Failure', error)
            )

    },
    disable({ commit, state }, data) {

    }
}


const mutations = {
    Loading(state) {
        state.loading = true;
    },
    Success(state, users) {
        state.users = users;
        state.loading = false;
    },
    Failure(state, error) {
        state.error = error;
    }
}

const getters = {
    USERS: state => {
        return state.users
    },

    USER_ERROR: state => {
        return state.error
    },
    USERS_LOADING: state => {
        return state.loading
    }


}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}